import {
  object,
  collection,
  number,
  boolean,
  string,
  date,
} from '@gogame/schemas';

import {
  campaignsSchema,
  createPlatformCampaign,
} from 'scenes/Campaigns/components/Form/Campaign/schema';
import { costModelSchema } from 'scenes/Campaigns/components/CostModel/schema';

import { CAMPAIGN_NAME } from 'scenes/Campaigns/components/Form/Campaign/constants';

import {
  COST_MODELS,
  CAMPAIGNS,
  APPLICATION,
  PLATFORM,
  RE_ENGAGEMENT,
  AFFILIATE,
  NETWORK,
  COUNTRY,
  LINK_EXPIRATION_DATE,
  TYPE,
  MEDIA_SOURCE,
  LINK_TYPE_ID,
  TRACKING_TYPE,
  LINK_TYPE,
  DEFAULT_TYPE,
  MISSING_MEDIA_SOURCE,
  PROMO_CODE,
  PARENT_CAMPAIGN,
  NAME,
} from 'scenes/Campaigns/components/Form/constants';

export const linksActivateSchema = object({
  [RE_ENGAGEMENT]: boolean(),
  [APPLICATION]: number().required(),
  [PLATFORM]: number().required(),
  [AFFILIATE]: number().required(),
  [NETWORK]: number().required(),
});

export const parentCampaignSchema = object({
  [CAMPAIGNS]: campaignsSchema,
  [TYPE]: number().default(1),
  [COST_MODELS]: collection(costModelSchema),
  [AFFILIATE]: number().required('Affiliate is required'),
  [APPLICATION]: number().required('Application is required'),
  [NETWORK]: number().required('Network is required'),
  [PLATFORM]: number().required('Platform is required'),
  [COUNTRY]: number().required('Country is required'),
  [MISSING_MEDIA_SOURCE]: boolean(),
  [MEDIA_SOURCE]: string().when(MISSING_MEDIA_SOURCE, {
    is: true,
    then: string().required('Media source is required'),
  }),
  [LINK_EXPIRATION_DATE]: date(),
  [LINK_TYPE_ID]: number().default(TRACKING_TYPE),
  [LINK_TYPE]: object({
    id: number(),
    name: string(),
  }).default(DEFAULT_TYPE),
});

export function duplicateCampaign({
  [NAME]: name,
  [CAMPAIGNS]: campaigns,
  [PROMO_CODE]: _promoCodeId,
  ...campaign
}) {
  return parentCampaignSchema.cast(
    {
      ...campaign,
      [PARENT_CAMPAIGN]: {
        [NAME]: `${name} the copy`,
      },
      [CAMPAIGNS]: campaigns?.map(
        ({ [CAMPAIGN_NAME]: campaignName, ...campaign }) =>
          createPlatformCampaign({
            [CAMPAIGN_NAME]: `${campaignName} the copy`,
            ...campaign,
          })
      ),
    },
    {
      context: {
        stripPeriodFinancialResultId: true,
        stripPeriodReadonly: true,
      },
    }
  );
}
